// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__xGeS+","tab":"TabBar_tab__6l7w6","icon":"TabBar_icon__e-K31","active":"TabBar_active__aotIo","ionLabel":"TabBar_ionLabel__Yz7JU"};